<template>
    <div class="loading d-flex text-center">
        <div class="nwLoader"></div>
    </div>
</template>

<script>
    export default {
        props: {
            template: {
                default: "#vue-loading-animation",
                type: String
            }
        }
    }
</script>
